const registerES = {
	title: "Crear tu cuenta de cliente",
	subtitle: "Una sola cuenta para reservar en todo Sin Fila.",
	sectionYou: "Sobre ti",
	sectionSecurity: "Seguridad",
	confirmPassword: "Confirmar contraseña",
	phone: "Teléfono",
	rememberMe: "Recordarme",
	email: "Correo electrónico",
	password: "Contraseña",
	firstName: "Nombre",
	lastName: "Apellido",
	submit: "Registrarse",
	loading: "Creando cuenta...",
	error: "No pudimos crear tu cuenta. Inténtalo de nuevo.",
	haveAccount: "¿Ya tienes una cuenta?",
	signIn: "Entrar",
	acceptTerms: "Acepto los",
	termsLink: "Términos y Condiciones",
	mustAcceptTerms: "Necesitamos que aceptes los Términos y Condiciones para continuar.",
	strength: {
		weak: "Contraseña débil",
		fair: "Vas bien",
		strong: "Contraseña segura",
	},
	rules: {
		length: "8+ caracteres",
		upper: "Mayúscula",
		lower: "Minúscula",
		number: "Número",
		symbol: "Símbolo",
	},
	match: {
		ok: "Las contraseñas coinciden",
		bad: "Las contraseñas aún no coinciden",
	},
};

export default registerES;
